export default {
	Geo: [
			{
				value:'geocoder', 
				text: 'geo.geo'
			},
			{
				value:'assisted', 
				text: 'geo.assisted'
			},
			{
				value:'inverse', 
				text: 'geo.reverse'
			},
	],
	Phone: [
			{
				value: 'mobile',
				text: 'phone.movil'
			},
			{
				value: 'fixed',
				text: 'phone.fixed'
			},
			{
				value: 'both',
				text: 'phone.movilFixed'
			}						
		],
	Radio: [
			{
				value: 'radio',
				text: 'radio.radio'
			},
			{
				value: 'select',
				text: 'radio.comoboBox'
			},												
			{
				value: 'multi',
				text: 'radio.unique'
			}
		],
	Password: [
			{
				value: 'alphanumeric',
				text: 'password.alphanumerico'
			},
			{
				value: 'string',
				text: 'password.string'
			},
			{
				value: 'numeric',
				text: 'password.number'
			}												
		],		
	Time: [
		{
			value: 'AM/PM',
			text: 'time.standar'
		},
		{
			value: 'MILITAR',
			text: 'time.militar'
		},
	],
	Fuentes: [
		{
			value: 'bold',
			text: 'fuentes.bold'
		},
		{
			value: 'normal',
			text: 'fuentes.normal'
		},
		{
			value: 'italic',
			text: 'fuentes.italic'
		},
	],
	Viewer: [
		{
			value: 'embedded',
			text: 'viewer.embebido'
		},
		{
			value: 'popup',
			text: 'viewer.popup'
		},
	],
	Paragraph: [		
		{
			value: 'content',
			text: 'paragraph.onlyParagraph'
		},
		{
			value: 'all',
			text: 'paragraph.titleParagraph'
		},
	],
	Orientation: [
		{
			value: 'default',
			text: 'orientation.default'
		},
		{
			value: 'landscape',
			text: 'orientation.landscape'
		},
		{
			value: 'portrait',
			text: 'orientation.portrait'
		},
	],
	View: [
		{
			value: 'external',
			text: 'View.external'
		},
		{
			value: 'popup',
			text: 'View.popup'
		},
	],
	MethodOrigin: [
		{
			value: 'write',
			text: 'methodOrigin.readWrite'
		},
		{
			value: 'read',
			text: 'methodOrigin.onlyRead'
		},
	],
	File: [
		{
			value: 'all',
			text: 'File.allExtensions'
		},
		{
			value: 'images',
			text: 'File.images'
		},
		{
			value: 'documents',
			text: 'File.documents'
		},
		{
			value: 'compressed',
			text: 'File.Compressed'
		},		
	]
}